import styled from 'styled-components'
import { em } from '../../../utils/styles'

const FormActions = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
  align-items: center;
  margin: ${em(40)} ${em(20)} 0;
`
export default FormActions
